import React, { useEffect, useState, Suspense } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Toaster } from "sonner";
import Navigation from "./containers/Header/Navigation";
import { routes } from "./routes";
import { Spinner } from "@nextui-org/react";
import UserState from "./userContext/UserState";
import getUserDetail from "./utils/getUserDetail";

function MainContent({ hamClick, isAuthenticated }) {
  const location = useLocation().pathname;

  return (
    <div
      className={
        location.includes("login") || location.includes("directives/print")
          ? ""
          : `absolute h-[calc(100%_-_55px)] top-[55px] ${hamClick
            ? "left-[70px] w-[calc(100%_-_70px)]"
            : "left-[250px] w-[calc(100%_-_250px)]"
          }`
      }
    >
      <div className="bg-[#f0f8ff] h-full w-full">
        <Suspense
          fallback={
            <div className="h-screen w-full flex justify-center items-center">
              <Spinner size="lg" className="scale-125" />
            </div>
          }
        >
          <Routes>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>
        </Suspense>
      </div>
    </div>
  );
}

const App = () => {
  const [hamClick, setHamClick] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    // Check initial auth status
    const user = getUserDetail();
    setIsAuthenticated(!!user?.id);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setHamClick(true);
      } else {
        setHamClick(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="h-screen w-full flex justify-center items-center bg-[#f0f8ff]">
        <div className="text-center">
          <Spinner size="lg" className="scale-125 mb-4" />
          <p className="text-gray-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <UserState>
        {isAuthenticated && (
          <Navigation hamClick={hamClick} setHamClick={setHamClick} />
        )}
        <MainContent hamClick={hamClick} isAuthenticated={isAuthenticated} />
        <Toaster richColors position="bottom-right" closeButton />
      </UserState>
    </BrowserRouter>
  );
};

export default App;
